
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7296"}},[_c('path',{attrs:{"data-name":"Path 382","d":"M32 0a18.67 18.67 0 1018.68 18.67A18.67 18.67 0 0032 0zm0 29.33a10.67 10.67 0 1110.68-10.66A10.68 10.68 0 0132 29.33z"}})]),_c('g',{attrs:{"data-name":"Group 7297"}},[_c('path',{attrs:{"data-name":"Path 383","d":"M15.9 34.61L5.58 53.15a2 2 0 00.08 2.05 1.94 1.94 0 001.84.91l8.21-.62 3.63 7.38A2.08 2.08 0 0021.07 64h.06a2.07 2.07 0 001.76-1l6.72-12-6.53-11.51a22.85 22.85 0 01-7.18-4.88z"}})]),_c('g',{attrs:{"data-name":"Group 7298"}},[_c('path',{attrs:{"data-name":"Path 384","d":"M58.41 53.14L48 34.72a22.44 22.44 0 01-12.8 6.37 22.06 22.06 0 01-6.64 0L31.9 47l9 16a2 2 0 001.73 1 2.07 2.07 0 001.76-1.12l3.66-7.39 8.37.64a2 2 0 001.89-3z"}})])])
          )
        }
      }
    